<ul class="tabs bootstrap">
  @for (tab of openTabs; track tab; let i = $index) {
    <li class="tab" [ngClass]="i === selectedTabIndex ? 'selected' : ''">
      <div class="tab-content" (click)="selectTab(i, tab)">
        <span>{{ tab.name }}</span>
      </div>
      <div class="close-button" (click)="deleteTab(i)">
        <span>
          ×
        </span>
      </div>
    </li>
  }
</ul>
